<template>
  <div class="group-box">
    <div class="box-title">
      <div class="title">系统默认</div>
      <div class="tips">不可修改</div>
    </div>
    <div class="box-list">
      <div v-for="(item, index) in systemSource" :key="index" class="box-one">
        <div :style="{ backgroundColor: item.color }" class="bgc"></div>
        <div class="name">{{ item.name }}</div>
      </div>
    </div>
  </div>

  <div class="group-box">
    <div class="box-title">
      <div class="title">自定义来源</div>
      <div>
        <a-button type="link" @click="openAdd">添加</a-button>
      </div>
    </div>
    <div class="box-list">
      <div
          v-for="(item, index) in customSource"
          :key="index"
          class="box-one"
          style="cursor: pointer"
          @click="openEdit(item)"
      >
        <div
            :style="{ backgroundColor: item.color }"
            class="bgc"
            title="点击编辑"
        ></div>
        <div class="name" title="点击编辑">{{ item.name }}</div>
        <div class="del" title="删除" @click.stop="handleDel(item)">
          <close-outlined/>
        </div>
      </div>
    </div>
  </div>

  <div class="group-box">
    <div class="box-title">
      <div class="title">自定义颜色标记</div>
      <div>
        <a-button type="link" @click="openAdd('color')">添加</a-button>
      </div>
    </div>
    <div class="box-list">
      <div
          v-for="(item, index) in customColor"
          :key="index"
          class="box-one"
          style="cursor: pointer"
          @click="openEdit(item, 'color')"
      >
        <div
            :style="{ backgroundColor: item.color }"
            class="bgc"
            title="点击编辑"
        ></div>
        <div class="name" title="点击编辑">{{ item.name }}</div>
        <div class="del" title="删除" @click.stop="handleDel(item, 'color')">
          <close-outlined/>
        </div>
      </div>
    </div>
  </div>

  <a-modal v-model:visible="visibleAdd" :title="modalTitle" @ok="modalOk">
    <a-form
        ref="formRef"
        :label-col="{ span: 4 }"
        :model="form"
        :rules="rules"
        :wrapper-col="{ offset: 1 }"
    >
      <a-form-item label="名称：" name="name">
        <a-input
            v-model:value="form.name"
            placeholder="请输入名称"
            style="width: 100%"
        />
      </a-form-item>
      <a-form-item label="颜色：" name="color">
        <a-input
            v-model:value="form.color"
            style="width: 30px; height: 34px; padding: 0 1px"
            type="color"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {CloseOutlined, ExclamationCircleOutlined,} from "@ant-design/icons-vue";
import {createVNode, onMounted, reactive, toRefs} from "vue";
import {colorAdd, colorDel, colorEdit, colorList, sourceAdd, sourceDel, sourceEdit, sourceList,} from "@/api/api";
import {message, Modal} from "ant-design-vue";

export default {
  components: {
    CloseOutlined,
  },
  setup() {
    const list = reactive({
      systemSource: [],
      customSource: [],
      customColor: [],
      // 获取来源列表
      getSourceList() {
        sourceList().then((res) => {
          list.systemSource = res.data.filter((i) => i.type !== 3);
          list.customSource = res.data.filter((i) => i.type == 3);
        });
      },
      // 获取颜色标记列表
      getColorList() {
        colorList().then((res) => {
          list.customColor = res.data;
        });
      },
      openAdd(type = "") {
        modal.form = {
          name: "",
          color: "#0094ff",
        };
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.visibleAdd = true;
        if (type == "color") {
          modal.modalTitle = "添加颜色标记";
          modal.type = "color";
        } else {
          modal.modalTitle = "添加来源";
          modal.type = "";
        }
      },
      openEdit(item, type = "") {
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.form.id = item.id;
        modal.form.name = item.name;
        modal.form.color = item.color;
        modal.visibleAdd = true;
        if (type == "color") {
          modal.modalTitle = "编辑颜色标记";
          modal.type = "color";
        } else {
          modal.modalTitle = "编辑来源";
          modal.type = "";
        }
      },
      // 删除账号
      handleDel(item, type = "") {
        if (type == "color") {
          Modal.confirm({
            title: "提示",
            content: "是否删除？",
            icon: createVNode(ExclamationCircleOutlined),
            centered: true,
            onOk() {
              colorDel({id: item.id}).then((res) => {
                message.success(res.msg);
                list.getColorList();
              });
            },
          });
        } else {
          Modal.confirm({
            title: "提示",
            content: "是否删除？",
            icon: createVNode(ExclamationCircleOutlined),
            centered: true,
            onOk() {
              sourceDel({option_id: item.id}).then((res) => {
                message.success(res.msg);
                list.getSourceList();
              });
            },
          });
        }
      },
    });

    const modal = reactive({
      type: "",
      visibleAdd: false,
      modalTitle: "",
      form: {
        name: "",
        color: "",
      },
      formRef: "",
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
      },
      modalOk() {
        if (modal.type == "color") {
          modal.formRef.validate().then(() => {
            if (modal.form.id) {
              colorEdit({
                name: modal.form.name,
                color: modal.form.color,
                id: modal.form.id,
              }).then((res) => {
                message.success(res.msg);
                modal.visibleAdd = false;
                list.getColorList();
              });
            } else {
              colorAdd(modal.form).then((res) => {
                message.success(res.msg);
                modal.visibleAdd = false;
                list.getColorList();
              });
            }
          });
        } else {
          modal.formRef.validate().then(() => {
            if (modal.form.id) {
              sourceEdit({
                name: modal.form.name,
                color: modal.form.color,
                option_id: modal.form.id,
              }).then((res) => {
                message.success(res.msg);
                modal.visibleAdd = false;
                list.getSourceList();
              });
            } else {
              sourceAdd(modal.form).then((res) => {
                message.success(res.msg);
                modal.visibleAdd = false;
                list.getSourceList();
              });
            }
          });
        }
      },
    });

    onMounted(() => {
      list.getSourceList();
      list.getColorList();
    });

    return {
      ...toRefs(modal),
      ...toRefs(list),
    };
  },
};
</script>

<style lang="scss" scoped>
.group-box {
  background-color: #fff;
  width: 100%;
  box-shadow: 0 0 5px #99999933;
  margin: 10px;

  .box-title {
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-bottom: 1px solid #f2f2f2;

    .title {
      font-size: 16px;
      color: #000000;
      margin-right: 10px;
    }

    .tips {
      color: #999999;
      font-size: 12px;
      margin-top: 2px;
    }
  }

  .box-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 20px;

    .box-one {
      padding: 6px 10px;
      border: 1px solid #cccccc;
      border-radius: 20px;
      min-width: 60px;
      display: flex;
      align-items: center;
      margin: 0 10px 10px 0;

      .bgc {
        height: 20px;
        width: 20px;
      }

      .name {
        margin-left: 5px;
      }

      .del {
        margin-left: 6px;

        &:hover {
          color: #da0000;
        }
      }
    }
  }
}
</style>
